import { cx } from "class-variance-authority";

import { PromoInsideIcon } from "./PromoInsideIcon";
import { ReactComponent as PromoEnclosedIcon } from "./assets/icon-promo-enclosed.svg";

import * as styles from "./SmallPromoIcon.module.scss";

export const SmallPromoIcon = ({
  className,
  variant = "inside",
  width = "18",
  height = "18",
}: {
  className?: string;
  width?: string;
  height?: string;
  variant?: "enclosed" | "inside";
}) => {
  const Icon = variant === "inside" ? PromoInsideIcon : PromoEnclosedIcon;
  return (
    <div className={styles.promoIconContainer}>
      <div className={cx(styles.promoIcon, className)}>
        <Icon width={width} height={height} />
      </div>
    </div>
  );
};
